var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#723DF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0003 33.3335V37.3335H36.0003V33.3335H45.3337V42.6668C45.3337 43.4032 44.7367 44.0002 44.0003 44.0002H20.0003C19.264 44.0002 18.667 43.4032 18.667 42.6668V33.3335H28.0003ZM30.667 30.6668H33.3337V34.6668H30.667V30.6668ZM25.3337 22.6668V18.6668C25.3337 17.9305 25.9306 17.3335 26.667 17.3335H37.3337C38.0701 17.3335 38.667 17.9305 38.667 18.6668V22.6668H44.0003C44.7367 22.6668 45.3337 23.2638 45.3337 24.0002V30.6668H36.0003V28.0002H28.0003V30.6668H18.667V24.0002C18.667 23.2638 19.264 22.6668 20.0003 22.6668H25.3337ZM28.0003 20.0002V22.6668H36.0003V20.0002H28.0003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/Bag.8163e39d9e46985fdb50942b69dcff4b.svg";
export { ForwardRef as ReactComponent };